import { ControlIcon as ControlIcon$1 } from './control-icon.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';

/**
 * @deprecated use `Icon` component instead
 */ const ControlIcon = deprecatedComponent({
    root: ControlIcon$1,
    displayName: 'ControlIcon',
    description: 'ControlIcon component is deprecated. Use <Icon> instead which is more flexible '
});

export { ControlIcon };
